<template>
        <div class="row mt-4" v-if="reportList.length > 0">
            <div class="col-md-12 mb-2">
                <h5 class="title">Relatórios</h5>
            </div>
            <Table :headers="headers" :items="reportList" />
        </div>
</template>

<script>
import assemblyService from '@/services/assembly-service';
import Table from '@/components/Custom/Table.vue';

export default {
    name: 'report-assembly',
    components: {
        Table
    },
    data() {
        return {
            totalPage: 0,
            currentPage: 1,
            limit: 0,
            reportList: [],
            querysParms: '',
            querySearch: undefined,
            headers: [
                {
                    text: "Nome do relatório",
                    value: "name",
                },
                {
                    text: "Ações",
                    value: "acoes",
                    align: "right",
                    type: "action",
                },
            ],
        }
    },
    props: {
        idAssembly: {
            type: String,
            require: true
        }
    },
    methods: {
        async getCsv(name) {
            switch (name) {
                case 'Status de votação':
                    return await assemblyService.getVotingStatusReport(this.idAssembly, name);
                    
                default:
                    this.$toast.error('Relatório não encontrado');
                    return;       
            }
        },
        async getReportsList() {
            this.reportList = [
                {
                    name: 'Status de votação',
                    acoes: [
                        {
                            color: "#fe7a01",
                            title: "Baixar relatório",
                            icon: "fa-regular fa-arrow-down-to-line",
                            onClick: (item) => {
                                this.getCsv(item.name)
                            },
                        },
                    ],
                }
            ];
        }
    },
    async mounted() {
        await this.getReportsList();
    },
}
</script>

<style scoped>
.icon-action {
    font-size: 1.3em;
}
</style>